type PaddingRecord = {
    top: number;
    right: number;
    bottom: number;
    left: number;
};

function getPaddingRecord(padding: number | Partial<PaddingRecord> | undefined): PaddingRecord {
    if (typeof padding === "number") {
        return { top: padding, right: padding, bottom: padding, left: padding };
    }

    if (!padding) {
        return { top: 0, right: 0, bottom: 0, left: 0 };
    }

    return {
        top: padding.top || 0,
        right: padding.right || 0,
        bottom: padding.bottom || 0,
        left: padding.left || 0
    };
}

export {
    PaddingRecord,
    getPaddingRecord
};
